import { z } from "zod";
import { apiGet, apiPut } from "../../shared/http.js";
import {
  ShelfConfigSchema,
  PutShelfConfigRequestSchema,
  type ShelfConfig,
  type PutShelfConfigRequest,
} from "@recipevault/shared";

const ShelfConfigResponseSchema = z.object({ config: ShelfConfigSchema });

export async function getShelfConfig(): Promise<ShelfConfig> {
  return ShelfConfigResponseSchema.parse(await apiGet<unknown>("/shelf-config")).config;
}

export async function putShelfConfig(body: PutShelfConfigRequest): Promise<ShelfConfig> {
  PutShelfConfigRequestSchema.parse(body);
  return ShelfConfigResponseSchema.parse(await apiPut<unknown>("/shelf-config", body)).config;
}
